import Vuex from 'vuex';
import LayoutState from 'components/layout/LayoutState';
import { viewSizeStore, viewSizeInit } from '@/stores/ViewSizeState';
import Cache, { cacheStateInit } from '@/stores/Cache';
import Vue from 'vue';
import AppState, { appStateInit } from '@/stores/AppState';
import ProvidersState from '@/stores/ProvidersState';
import MediationAppState from '@/stores/MediationAppState';
import CountriesState from '@/stores/CountriesState';
import CVStatsSCache from '@/pages/conversionValue/cvManager/statsCache';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        layout: LayoutState,
        viewSize: viewSizeStore,
        cache: Cache,
        providers: ProvidersState,
        mediationApplications: MediationAppState,
        apps: AppState,
        countries: CountriesState,
        cvStats: CVStatsSCache
    }
});
viewSizeInit(store);
appStateInit(store);
cacheStateInit(store);

export default store;
